import { FC, useRef } from 'react';
import { useSelector } from 'react-redux';
import { CSSTransition } from 'react-transition-group';

import { RootState } from '../../../ducks/store';

import './OutletWrapper.scss';

interface IProps {}

const OutletWrapper: FC<IProps> = ({ children }) => {
  const { showLeft, showRight } = useSelector((state: RootState) => {
    const { panes } = state;
    const { showLeft, showRight } = panes;
    return {
      showLeft,
      showRight,
    };
  });

  const ref = useRef(null);
  return (
    <CSSTransition in={showLeft} timeout={300} classNames="OutletWrapper" nodeRef={ref}>
      <div className="OutletWrapper" ref={ref}>
        {children}
      </div>
    </CSSTransition>
  );
};

export default OutletWrapper;
